import React from "react";

export default function PageHeader({ eyebrow, title, sub, image }) {
  return (
    <section data-testid="page-header" className="relative bg-[#0A192F] text-white overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A192F]/50 via-[#0A192F]/40 to-[#0A192F]/90" />
        </div>
      )}
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-28 lg:py-36">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] reveal reveal-1">{eyebrow}</p>
        <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight mt-6 max-w-4xl reveal reveal-2">
          {title}
        </h1>
        {sub && (
          <p className="mt-8 text-lg text-white/75 max-w-2xl reveal reveal-3">{sub}</p>
        )}
      </div>
      <div className="relative h-1 w-full">
        <div className="absolute left-0 top-0 h-1 w-32 bg-[#C5A059]" />
      </div>
    </section>
  );
}
